<template>
  <div>
    <canvas :id="`bar-chart-${id}`" height="400"></canvas>
  </div>
</template>

<script>
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "BarChartTime",
  props: {
    data: {
      type: Array,
      require: true,
    },
    data2: {
      type: Array,
      require: false,
      default: () => [],
    },
    id: {
      type: [String, Number],
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true,
    },
    maxValue: {
      type: Number,
      require: false,
      default: 0,
    },
    textX: {
      type: [String],
      require: false,
    },
    textX2: {
      type: [String],
      require: false,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "count",
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          },
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                if (value % 1 === 0) {
                  return value;
                }
              },
            },
            suggestedMax: this.maxValue,
            title: {
              display: true,
              align: "center",
              text: "Number of Chat",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            grid: {
              drawOnChartArea: false,
            },
            beginAtZero: true,
            title: {
              display: true,
              align: "center",
              // text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 0 },
            },
            ticks: {
              callback: (value, index, ticks) => {
                // Use the first dataset to get labels, with safety check
                const dataItem = this.data && this.data[index];
                if (!dataItem) return "";

                if (dataItem.name.length <= 20) {
                  return `${dataItem.name}`;
                } else {
                  return `${dataItem.name.substring(0, 20)}...`;
                }
              },
            },
          },
        },
        plugins: {
          datalabels: {
            display: (context) => {
              const index = context.dataIndex;
              const isShow = context.dataset.data[index].count;
              return isShow ? "auto" : false;
            },
            textAlign: "top",
            anchor: "end",
            align: "top",
            offset: -5,
            font: {
              size: 12,
            },
            formatter: (value, context) => {
              let data = this.addCommas(value.count);
              return data;
            },
          },
          legend: {
            display: true,
            position: "bottom",
            labels: { boxWidth: 10, boxHeight: 10 },
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: (context) => {
                const contextElement = context[0];
                const index = contextElement.dataIndex;
                const label = "";
                const value = contextElement.dataset.data[index];
                // const percent = value.percentFormat
                const count = value.count;
                let result = this.addCommas(count);

                let labels = `${result} ${contextElement.dataset.label}`;
                let splitStr = value.name.match(/.{1,49}/g);
                splitStr.forEach((element) => {
                  labels += `\n${element}`;
                });

                return labels;
              },
              label: (context) => {
                return;
              },
              afterLabel: (context) => {
                return;
              },
            },
          },
        },
      },
    };
  },
  async mounted() {
    const ctx = document
      .getElementById(`bar-chart-${this.id}`)
      .getContext("2d");

    // Create datasets array
    const datasets = [
      {
        backgroundColor: "#7160C4",
        data: this.data,
        label: this.textX || "Number of Chat",
        borderRadius: {
          bottomLeft: 0,
          bottomRight: 0,
          topLeft: 5,
          topRight: 5,
        },
      },
    ];

    // Add second dataset if data2 is provided
    if (this.data2 && this.data2.length > 0) {
      datasets.push({
        backgroundColor: "#5CB3CC",
        data: this.data2,
        label: this.textX2 || "Customer",
        borderRadius: {
          bottomLeft: 0,
          bottomRight: 0,
          topLeft: 5,
          topRight: 5,
        },
      });
    }

    await new Chart(ctx, {
      type: "bar",
      data: {
        datasets: datasets,
      },
      plugins: [ChartDataLabels],
      options: this.options,
    });
  },
  methods: {
    addCommas(nStr) {
      var x, x1, x2;

      nStr += "";
      x = nStr.split(".");
      x1 = x[0];
      x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
  },
};
</script>
<style lang="scss" scoped></style>
